export default __webpack_public_path__ + "static/media/Donna.c4b92452.png";